import { axios } from '@ben/api/axios';
import type { AxiosRequestConfig } from 'axios';
import type { BenefitImage } from '@ben/api/gen/codegen.schemas';

export const uploadBenefitImage = async (
  data: unknown,
  options?: AxiosRequestConfig<unknown>
): Promise<BenefitImage> => {
  const response = await axios.post<BenefitImage>(
    `benefit-image/`,
    data,
    options
  );
  return response.data;
};
